/**
 * @generated SignedSource<<1288544fc8d678cffb3339d21d7493cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type PaymentProcessor = "BRAINTREE" | "KLARNA" | "OFF_PLATFORM" | "STRIPE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type checkoutTransactionReducer_transaction$data = {
  readonly availablePaymentMethods: ReadonlyArray<{
    readonly paymentMethodType: string | null;
    readonly paymentProcessor: PaymentProcessor | null;
  } | null> | null;
  readonly " $fragmentType": "checkoutTransactionReducer_transaction";
};
export type checkoutTransactionReducer_transaction$key = {
  readonly " $data"?: checkoutTransactionReducer_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutTransactionReducer_transaction"
};

(node as any).hash = "3993af6dbc1fa178aabb1bf7d08020e8";

export default node;
